import defaultIcon from '@/assets/branding/zyncro-icon.svg'
import defaultWordmark from '@/assets/branding/zyncro-logo.svg'

const LEGACY_DEFAULT_LOGOS = [
  'images/logo.png',
  'storage/images/settings/logo.png',
]

const LEGACY_DEFAULT_ICONS = [
  'images/favicon.png',
  'storage/images/settings/favicon.png',
]

const LEGACY_DEFAULT_LOGIN_IMAGES = [
  'images/background.png',
  'storage/images/settings/background.png',
]

function normalizePath(value) {
  if (!value) return ''

  return String(value)
    .split('?')[0]
    .split('#')[0]
    .replace(/^https?:\/\/[^/]+\//i, '')
    .replace(/^\/+/, '')
    .replace(/^backend\/public\//, '')
}

function isCustomized(url, metadataValue, defaultPaths) {
  if (typeof metadataValue === 'boolean') return metadataValue
  if (!url) return false

  const path = normalizePath(url)
  const usesLegacyDefault = defaultPaths.some(defaultPath => {
    return path === defaultPath || path.endsWith('/' + defaultPath)
  })

  return !usesLegacyDefault
}

const Branding = {
  defaults: {
    icon: defaultIcon,
    wordmark: defaultWordmark,
  },

  resolve(settings) {
    const currentSettings = settings || {}
    const metadata = currentSettings.branding || {}
    const logo = currentSettings.logo || ''
    const icon = currentSettings.favicon || ''
    const login = currentSettings.image_login || ''
    const logoContrast = ['auto', 'light', 'dark'].indexOf(currentSettings.logo_contrast) !== -1
      ? currentSettings.logo_contrast
      : 'auto'
    const logoCustomized = isCustomized(
      logo,
      metadata.logo_customized,
      LEGACY_DEFAULT_LOGOS
    )
    const iconCustomized = isCustomized(
      icon,
      metadata.icon_customized,
      LEGACY_DEFAULT_ICONS
    )
    const loginCustomized = isCustomized(
      login,
      metadata.login_customized,
      LEGACY_DEFAULT_LOGIN_IMAGES
    )

    return {
      logo,
      icon,
      login,
      logoContrast,
      logoCustomized,
      iconCustomized,
      loginCustomized,
      compactSource: iconCustomized && icon ? icon : defaultIcon,
      defaultIcon,
      defaultWordmark,
    }
  },
}

export default Branding
